import {Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, scan} from 'rxjs/operators';
import {BaseComponent} from '../base.component';
import {AdobeLaunchService} from '@ui-app/services/adobe-launch.service';

@Component({
    selector: 'ui-search-block',
    templateUrl: './search-block.component.html',
    styleUrls: ['./search-block.component.less']
})
export class SearchBlockComponent extends BaseComponent implements OnInit, OnChanges {

    searchForm: UntypedFormGroup = new UntypedFormGroup({
        search: new UntypedFormControl()
    });

    private queryString$ = new Subject<string>();

    constructor(private adobeLaunchService: AdobeLaunchService) {
        super();
    }

    @Input() query = '';
    @Input() placeholderText = '';
    @Input() enableAutoSearch = false;
    @Input() minQueryLength: number = 3;
    @Input() maxQueryLength: number = 50;

    @Output() search: EventEmitter<string> = new EventEmitter<string>();
    @Output() changeInput: EventEmitter<string> = new EventEmitter<string>();

    ngOnInit(): void {
        this.searchForm.get('search').setValue(this.query);
        this.handleSearch();
        this.disableSearch();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.query) {
            this.searchForm.get('search').setValue(this.query);
        }
    }

    private handleSearch(): void {
        this.subs = this.queryString$.pipe(
            distinctUntilChanged(),
            debounceTime(200)
        )
            .subscribe((searchQuery: string) => {
                const trimmedQuery = searchQuery.trim();
                const lettersQuantity = trimmedQuery.replace(/ /g, '').length;
                if (lettersQuantity >= this.minQueryLength || lettersQuantity === 0) {
                    this.search.emit(trimmedQuery);
                    if (trimmedQuery) {
                        this.adobeLaunchService.trackSearch(trimmedQuery);
                    }
                }
                this.searchForm.get('search').setValue(trimmedQuery);
            });
    }

    private disableSearch(): void {
        /**
         * @todo
         * clarify and implement
         */
    }

    performSearch(): void {
        this.queryString$.next(this.searchForm.get('search').value);
    }

    searchByEnter(): void {
        if (this.enableAutoSearch) {
            return;
        }
        this.performSearch();
    }

    resetState(): void {
        this.searchForm.get('search').reset('');
        this.performSearch();
    }


    emitSearchValue(): void {
        const searchValue = this.searchForm.get('search').value;
        if (searchValue === ' ') {
            this.searchForm.get('search').setValue('');
        }
        if (this.enableAutoSearch) {
            this.performSearch();
        }
        this.changeInput.emit(this.searchForm.get('search').value);
    }

}
